import {
    CheckCircleFilled,
    CloseCircleFilled,
    MinusCircleFilled,
} from "@ant-design/icons"


export const LANGUAGE_MODE = {
    ENGLISH: 'EN',
    MALAY: 'MY'
}

export const PRETRIP_WORDINGS = {
    [LANGUAGE_MODE.ENGLISH]: {
        select: 'Select Language',
        color: '#CC0001',
        title: 'Pre-departure Checklist',
        subtitle: 'APAD Guideline | Mandatory Before Trip',
        ident_title: 'Driver Identification',
        ident_subtitle: 'Enter your IC number to start the pre-departure checklist',
        howto_title: 'How to Complete this Checklist',
        howto_list: [
            'Read each item carefully before checking',
            'Tick ✓ all items that meet the requirements',
            'Leave items unchecked if they do NOT meet requirement',
            'If you\'re unsure about any item, contact your supervisor'
        ],
        driver: 'DRIVER',
        plate: 'Vehicle Plate',
        date: 'Date',
        vytype: 'Vehicle',
        check_title: 'Confirm',
        check_confirm: 'I confirm that all checks have been completed correctly and I will comply with road safety regulations.',
    },
    [LANGUAGE_MODE.MALAY]: {
        select: 'Pilih Bahasa',
        color: '#00247D',
        title: "Senarai Semak Sebelum Bertolak",
        subtitle: "Garis Panduan APAD | Wajib Sebelum Perjalanan",
        ident_title: "Pengenalan Pemandu",
        ident_subtitle: "Masukkan nombor IC anda untuk memulakan senarai semak sebelum bertolak",
        howto_title: "Cara Melengkapkan Senarai Semak Ini",
        howto_list: [
            "Baca setiap item dengan teliti sebelum tanda",
            "Tanda ✓ pada semua item yang memenuhi syarat",
            "Biarkan item tidak bertanda jika TIDAK memenuhi syarat",
            "Jika anda tidak pasti tentang mana-mana item, hubungi penyelia anda"
        ],
        driver: 'PEMANDU',
        plate: 'No. Kenderaan',
        date: 'Tarikh',
        vytype: 'Kenderaan',
        check_title: 'Pengesahan',
        check_confirm: 'Saya mengesahkan bahawa semua pemeriksaan telah dilakukan dengan betul dan saya akan mematuhi peraturan keselamatan jalan raya.'
    }
}


export const PRETRIP_HISTORY_STATUS = {
    SUBMITTED: "SUBMITTED",
    MISSING: "MISSING",
    INCOMPLETE: "INCOMPLETE",
    OFF: "OFF",
}


export const PRETRIP_HISTORY_STATUS_LABEL = {
    [PRETRIP_HISTORY_STATUS.SUBMITTED]: {
        label: "Submitted",
        color: "#22c55e",
        bg: "#f0fdf4",
        textColor: "#15803d",
        icon: <CheckCircleFilled style={{ color: "#22c55e", fontSize: 18 }} />,
        tagColor: "success",
        status: PRETRIP_HISTORY_STATUS.SUBMITTED
    },
    [PRETRIP_HISTORY_STATUS.MISSING]: {
        label: "Missing",
        color: "#ef4444",
        bg: "#fef2f2",
        textColor: "#dc2626",
        icon: <CloseCircleFilled style={{ color: "#ef4444", fontSize: 18 }} />,
        tagColor: "error",
        status: PRETRIP_HISTORY_STATUS.MISSING
    },
    // [PRETRIP_HISTORY_STATUS.INCOMPLETE]: {
    //     label: "Incomplete",
    //     color: "#f59e0b",
    //     bg: "#fffbeb",
    //     textColor: "#d97706",
    //     icon: <MinusCircleFilled style={{ color: "#f59e0b", fontSize: 18 }} />,
    //     tagColor: "warning",
    //     status: PRETRIP_HISTORY_STATUS.INCOMPLETE
    // },
    [PRETRIP_HISTORY_STATUS.OFF]: {
        label: "Off Day",
        color: "#9ca3af",
        bg: "#f3f4f6",
        textColor: "#6b7280",
        icon: <MinusCircleFilled style={{ color: "#9ca3af", fontSize: 18 }} />,
        tagColor: "default",
        status: PRETRIP_HISTORY_STATUS.OFF
    },
}